import React, { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { Outlet, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getItem } from '../../utils/localStorage';
import { _fetchUserData } from '../../store/actions/user';
import Lottie from "lottie-react";
import bydoLoading from "../assets/lottie/main-loading.json";

const AuthRoute = () => {
    const dispatch = useDispatch();
    const { isAuthenticated, loading, profileLoad } = useSelector((state) => state.user);
    const [isAuthCheckComplete, setIsAuthCheckComplete] = useState(false);

    useEffect(() => {
        const token = getItem("user")?.token;

        // If already authenticated, no need to verify
        if (isAuthenticated) {
            setIsAuthCheckComplete(true);
            return;
        }

        // If profile is being loaded (App.jsx is already fetching), wait for it to complete
        if (profileLoad) {
            // Wait for profileLoad to finish
            return;
        }

        // If profileLoad is false and we're not authenticated, check is complete
        if (!profileLoad) {
            if (token) {
                // Token exists but user not authenticated after profile load
                // This means token is invalid, allow access to auth routes
                setIsAuthCheckComplete(true);
            } else {
                // No token, so user is definitely not authenticated, allow access to auth routes
                setIsAuthCheckComplete(true);
            }
        }
    }, [dispatch, isAuthenticated, profileLoad]);

    // If authentication check is still in progress, show loading
    // But don't show loading if user is explicitly not authenticated (after logout)
    const shouldShowLoading = !isAuthCheckComplete && (loading || profileLoad);
    
    if (shouldShowLoading) {
        return (
            <div className="flex flex-col justify-center items-center h-screen text-center">
                <Lottie animationData={bydoLoading} loop={true} className="h-[200px]" />
                <span className="relative -top-5 text-sm font-bold text-primary-900">
                    Verifying authentication...
                </span>
                <Toaster />
            </div>
        );
    }

    // If authenticated after check, redirect to dashboard
    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // If not authenticated, render the auth routes
    return (
        <div className="w-full h-screen banner flex justify-center items-center bg-indigo-50">
            <Outlet />
            <Toaster />
        </div>
    );
};

export default AuthRoute;
